export const searchForm = {
  city_id: undefined, // 城市
  address: '', // 地址
  project: undefined // 品牌
}

export const form = {
  province: '',
  province_id: '',
  city: '',
  city_id: '',
  area: '',
  area_id: '',
  address: '',
  longitude: '',
  latitude: '',
  phone: '',
  zip_code: '',
  email: '',
  img: ''
}

export const rules = {
  area_id: [{ required: true, message: '请选择地区', trigger: 'change' }],
  abbreviation: [{ required: true, message: '请输入公司简称', trigger: 'change' }],
  company_name: [{ required: true, message: '请输入公司全称', trigger: 'change' }],
  address: [{ required: true, message: '请输入地址', trigger: 'change' }],
  target: [{ required: true, message: '请选择打开方式', trigger: 'change' }],
  responsible: [{ required: true, message: '请选择负责人', trigger: 'change' }],
  telephone: [{ required: true, message: '请输入座机号', trigger: 'change' }],
  mobile: [
    {
      required: true,
      message: "请输入手机号码",
      trigger: "change"
    },
    {
      validator: function (rule, value, callback) {
        if (/^1[345789]\d{9}$/.test(value) === false) {
          callback(new Error("手机号格式错误"))
        } else {
          callback()
        }
      },
      trigger: "blur"
    }
  ],
}
